import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=12aec993&scoped=true"
import script from "./AppSideBar.vue?vue&type=script&lang=ts"
export * from "./AppSideBar.vue?vue&type=script&lang=ts"
import style0 from "./AppSideBar.vue?vue&type=style&index=0&id=12aec993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aec993",
  null
  
)

export default component.exports